import React, {Component} from 'react';
import intl from "react-intl-universal";
import Title from "./Title";
import Appearance from "./Appearance";
import Car from "./Car";
import "./css/Traumatism.scss"

class Traumatism extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        const trauma_url = require("../assets/normal.png");

        let {images, tyre_lf, tyre_rf, tyre_lb, tyre_rb} = this.props.data;
        const returnColor = (content, degree) => {
                if (degree === 'damage_high') {
                    return {color: 'red', degree: 'high', damage: 'high'}
                }
                if (content) {
                    if (content === 'trauma_normal') {
                        return {color: 'green', degree: 'low', damage: 'low'}
                    } else {
                        return {color: '#ffca11', degree: 'middle', damage: 'middle'}
                    }
                } else {
                    return {color: 'green', degree: 'low', damage: 'low'}
                }
            }
        ;

        const returnImage = (img, trauma) => {
            if (trauma !== 'trauma_normal') {
                if (img) {
                    if (img.indexOf("img1")>=0 && img.indexOf("img2")>0 && img.indexOf("img3")>0){
                        let imgjson = JSON.parse(img)
                        return (
                            <div>
                                <img className="tra-img" src={imgjson.img1} alt=""/>
                                {/* <img className="tra-img-sub" src={imgjson.img2} alt=""/>
                                <img className="tra-img-sub" src={imgjson.img3} alt=""/> */}
                            </div>
                        )
                    }else
                    {
                        return <img className="tra-img" src={img} alt=""/>
                    } 
                }else {
                    return ''
                }
            } else {
                return <img className="tra-img" src={trauma_url} alt=""/>
            }
        };

        const trauma_type = (type) => {
        // console.log(type);
        if(type){
            let _list = type.split(';');
        _list.forEach(function (value, index) {
            if (value === 'trauma_normal') {
                _list[index] = intl.get('trauma_normal')
            } else if (value === 'trauma_bulge') {
                _list[index] = intl.get('trauma_bulge')
            } else if (value === 'trauma_aging') {
                _list[index] = intl.get('trauma_aging')
            } else if (value === 'trauma_lacerate') {
                _list[index] = intl.get('trauma_lacerate')
            } else if (value === 'trauma_dropblock') {
                _list[index] = intl.get('trauma_dropblock')
            } else if (value === 'trauma_puncture') {
                _list[index] = intl.get('trauma_puncture')
            } else if (value === 'trauma_scratch') {
                _list[index] = intl.get('trauma_scratch')
            } else if (value === 'trauma_pinnate') {
                _list[index] = intl.get('trauma_pinnate')
            } else if (value === 'trauma_eattyre') {
                _list[index] = intl.get('trauma_eattyre')
            } else {
                return type.split('other')[1]
            }
        })
        let _str = _list.join(';')
        return _str
        }else {
            return  intl.get('trauma_normal')
        }
    };



        return (
            <div className="traum">
                <div>
                    <Title content={intl.get('trauma')}/>
                </div>
                <div>
                    <div style={{paddingLeft: 15}}>
                        <Appearance content={tyre_lf.install}></Appearance>
                    </div>
                    <div className="tra-con">
                        <div className="tra-lf">
                            <div>
                                <p>{intl.get('lf')}:</p><p
                                style={returnColor(tyre_lf.trauma, tyre_lf.degree)}>{trauma_type(tyre_lf.trauma)}</p>
                            </div>
                            <div>{returnImage(images.trauma_lf_img, tyre_lf.trauma)}</div>
                        </div>
                        <div className="tra-lb">
                            <div>
                                <p>{intl.get('rf')}:</p><p
                                style={returnColor(tyre_lb.trauma, tyre_lb.degree)}>{trauma_type(tyre_lb.trauma)}</p>
                            </div>
                            <div>{returnImage(images.trauma_lb_img, tyre_lb.trauma)}</div>
                        </div>
                        <div className="tra-con-cen"><Car data={{
                            lf: returnColor(tyre_lf.trauma, tyre_lf.degree),
                            lb: returnColor(tyre_lb.trauma, tyre_lb.degree),
                            rf: returnColor(tyre_rf.trauma, tyre_rf.degree),
                            rb: returnColor(tyre_rb.trauma, tyre_rb.degree)
                        }}/></div>
                        <div className="tra-rf">
                            <div>{returnImage(images.trauma_rf_img, tyre_rf.trauma)}</div>
                            <div>
                                <p>{intl.get('lr')}:</p><p
                                style={returnColor(tyre_rf.trauma, tyre_rf.degree)}>{trauma_type(tyre_rf.trauma)}</p>
                            </div>
                        </div>
                        
                        <div className="tra-rb">
                            <div>{returnImage(images.trauma_rb_img, tyre_rb.trauma)}</div>
                            <div>
                                <p>{intl.get('rr')}:</p><p
                                style={returnColor(tyre_rb.trauma, tyre_rb.degree)}>{trauma_type(tyre_rb.trauma)}</p>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        )
    }
}

export default Traumatism;


